import styles from "./Selector.module.css";

import { useState, useEffect } from "react"
import Icon from "./Icon";
import LoadingSpinner from "./LoadingSpinner";


/**
 * @author  kim young jun
 * @date    2025-06-11
 * @param   props 
 * @return  Selector
 */

export interface SelectorItems {
    key: string;
    label: string;
    icon: string;
    isActive: boolean;
    isHover: boolean;
}

interface selectorProps {
    items: SelectorItems[];
    selectedKey: string;
    onChange: (key: string) => void;
    onMouseOver?: (key: string) => void;
    onMouseOut?: () => void;
    isReverse?: boolean;
    // loadingKey?: number;
}

function Selector(props: selectorProps) {

    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 780);
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const items = props.isReverse && !isMobileView
        ? [...props.items].reverse()
        : props.items;

    return (
        <div className={styles.selector_container}>
            {items.map(({ key, label, icon, isActive, isHover }) => {
                const isDisabled = label === "이야기";

                return (
                    <div
                        key={key}
                        className={`${styles.item} ${isDisabled ? styles.disabled : ""}`}
                        onClick={() => {
                            if (!isDisabled) props.onChange(key);
                        }}
                        onMouseOver={() => {
                            if (!isDisabled) props.onMouseOver?.(key);
                        }}
                        onMouseOut={() => {
                            if (!isDisabled) props.onMouseOut?.();
                        }}
                    >
                        <div className={`${styles.icon_container} ${isActive ? styles.active : ""}`}>
                            {icon && (
                                <Icon
                                    name={icon}
                                    size="small"
                                    color={isDisabled ? "lightgray" : isActive ? "white" : isHover ? "default" : "buttonDarkGrey"}
                                />
                            )}
                        </div>
                        {label && (
                            <span className={`${styles.label} ${(isActive || isHover) ? styles.active : ""} ${isDisabled ? styles.disabled : ""}`}>
                                {label}
                            </span>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

export default Selector;